import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Client-side navigation keeps the old scroll position; start each new page at the top.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
